import RoleMembership from './role-membership';

export default function RolesMembershipPage() {
  return <RoleMembership />;
}
